/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { EdsIcon, CosmosText } from "@components/elements";
import { EdsIconsEnum, LicenseCardTopFragment } from "@cosmos/hygraph-schema";
import { useState } from "react";

import { css } from "@panda/css";
import { HStack, VStack } from "@panda/jsx";

import { LicenseCardDescription } from "./LicenseCardDescription.molecule";

interface Props extends LicenseCardTopFragment {
	showExampleLabel?: string | null;
	hideExampleLabel?: string | null;
}

export const LicenseCardTop = ({
	icon,
	title,
	description,
	example,
	showExampleLabel = "Show example",
	hideExampleLabel = "Hide example",
}: Props): React.JSX.Element => {
	const [show, setShow] = useState(false);

	// fix issue where Hygraph rich text adds a <p> tag after an entry with only a <ul>
	let cleanedExampleHtml = example?.html || "";
	if (cleanedExampleHtml?.trim().endsWith("<p></p>")) {
		cleanedExampleHtml = cleanedExampleHtml.substring(0, cleanedExampleHtml.length - 7).trim();
	}

	const showButtonEl = (
		<button
			className={css({
				cursor: "pointer",
				color: "eds.text.link.primary.default",
				transition: `color token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)`,
				_hover: {
					color: "eds.text.link.primary.press",
				},
			})}
			onClick={() => {
				setShow(!show);
			}}
		>
			<HStack gap="2px">
				<CosmosText variant="paragraphMD" text={show ? hideExampleLabel || "" : showExampleLabel || ""} />
				<EdsIcon icon={show ? "ChevronUp" : "ChevronDown"} size="sm" />
			</HStack>
		</button>
	);

	const exampleEl = show ? (
		<VStack alignItems="flex-start" gap="0">
			<LicenseCardDescription textStyle="paragraphMD" html={cleanedExampleHtml} />
			{showButtonEl}
		</VStack>
	) : (
		showButtonEl
	);

	return (
		<VStack alignItems="flex-start" gap="eds.dimension.16">
			<HStack gap="eds.dimension.24">
				<EdsIcon size="lg" icon={icon as EdsIconsEnum} />
				<CosmosText variant="headingLG" as="h3">
					{title}
				</CosmosText>
			</HStack>
			<VStack alignItems="flex-start" gap="eds.dimension.16">
				<LicenseCardDescription textStyle="paragraphMD" html={description?.html} />
				{cleanedExampleHtml ? exampleEl : null}
			</VStack>
		</VStack>
	);
};
